import React, { useEffect } from "react";
import Table from "../../../../../components/common/Table"
import { CloseButton } from "components/EnsembleComponents/BACNetComponents/_ModalForms/ManageSecureConnect/styled";
import { withRouter } from 'react-router-dom';
import { useFetchSecureConnectedDevices } from "./useFetchAPIData";
import { FaArrowLeft } from "react-icons/fa";
import { useGetLocalizationLabel } from "components/EnsembleComponents/BACNetComponents/_ModalForms/ManageSecureConnect/useAPIMethods";
import { FormErrorContainer, ErrorSection } from "components/EnsembleComponents/BACNetComponents/_ModalForms/ViewHubParameters/styled";
import { MdWarning, MdClose } from "react-icons/md";
import Spinner from "components/common/LegacySpinner";
import { SpinnerContainer } from "components/EnsembleComponents/BACNetComponents/_ModalForms/ManageSecureConnect/styled";
import { useDateTimeByUserFormat } from "utils";

const ViewSecureConnectedDevices = ({ history }) => {
    const retrieveNetworkID = sessionStorage.getItem('retrieveNetworkID');
    const retrieveNetworkName = sessionStorage.getItem('retrieveNetworkName');
    const { data: connectedDeviceList, loading, error, errorMessage, refetch, updateAPIData } =
        useFetchSecureConnectedDevices({ secureNetworkId: retrieveNetworkID });
    const { getLabel } = useGetLocalizationLabel();
    const { getDateTimeValue } = useDateTimeByUserFormat();

    useEffect(() => {
      const fetchUpdatedData = setInterval(() => {
        refetch(true);
      }, 10000);
      
      return () => {
        clearInterval(fetchUpdatedData);
      }
    }, []);

    const columns = [
      {
        label: getLabel("NodeVMAC") ? getLabel("NodeVMAC") : "Node VMAC",
        key: "nodeVMAC",
        align: "left",
        sort: true
      },
      {
        label: getLabel("DeviceId") ? getLabel("DeviceId") : "Device Id",
        key: "deviceID",
        align: "left",
        sort: true,
        customComponent: (rowData, column) => (<div>{rowData[column.key] ? rowData[column.key] : "--" }</div>)
      },
      {
        label: getLabel("DeviceName") ? getLabel("DeviceName") : "Device Name",
        key: "deviceName",
        align: "left",
        sort: true,
        customComponent: (rowData, column) => (<div>{rowData[column.key] ? rowData[column.key] : "--" }</div>)
      },
      {
        label: getLabel("LastConnectedDate") ? getLabel("LastConnectedDate") : "Last Connected Date",
        key: "lastConnectedDate",
        align: "left",
        sort: true,
        customComponent: (rowData, column) => (<div>{rowData[column.key] ? getDateTimeValue(rowData[column.key], "MMM-DD-YYYY HH:mm Z") : "--" }</div>)
      },
      {
        label: getLabel("Status") ? getLabel("Status") : "Status",
        key: "statusDescription",
        align: "left",
        sort: true
      },
      {
        label: getLabel("NodeUUID") ? getLabel("NodeUUID") : "Node UUID",
        key: "nodeUUID",
        align: "left",
        defaultSorted: "asc",
        sort: true
      }
    ];
    return (<div className="secure-connected-devices">
                <label className="header-label">{ getLabel("SecureNetwork") ? getLabel("SecureNetwork") : "Secure Network:" } {retrieveNetworkName}</label>
                <div>
                    <Table
                        columns={columns}
                        data={connectedDeviceList && connectedDeviceList.length ? connectedDeviceList : []}
                        fixedHeader
                        tableId="node-device-connected"
                        containerHeight="auto"
                        noDataCellCustomStyle={{
                            paddingLeft: "45%",
                            wordBreak: "keep-all",
                            whiteSpace: "nowrap",
                            position: "relative",
                            top: "5vh"
                        }}
                    />
                </div>
                <div>
                <CloseButton mr="0" mt="15px" variant="contained" onClick={() => history.goBack()}><FaArrowLeft />{ getLabel("Back") ? getLabel("Back") : "Back" }</CloseButton>
                </div>
                {
                  error ? <ErrorSection>
                      <FormErrorContainer>
                          <MdWarning />
                          <b>{errorMessage}</b>
                      </FormErrorContainer>
                        <div>
                            <MdClose onClick={() => updateAPIData(prevState => ({ ...prevState, error: false, errorMessage: "" }))}/>
                        </div>
                    </ErrorSection> : null
                }
                 { loading ? <SpinnerContainer>
                        <Spinner />
                    </SpinnerContainer> : null
                }
            </div>
            )
    }

export default withRouter(ViewSecureConnectedDevices);